const KEY = "theme"; // "light" | "dark"

export function getTheme() {
    return localStorage.getItem(KEY) || "light";
}

function hexToRgb(hex) {
    const clean = hex.replace("#", "");
    const full = clean.length === 3 ? clean.split("").map((c) => c + c).join("") : clean;
    const num = parseInt(full.slice(0, 6), 16);
    return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 };
}

function rgbToHex({ r, g, b }) {
    const clamp = (v) => Math.min(255, Math.max(0, Math.round(v)));
    return `#${[r, g, b].map((c) => clamp(c).toString(16).padStart(2, "0")).join("")}`;
}

// затемнение цвета к чёрному на заданный процент — для hover/active оттенка (аналог --primary-700)
function darken(hex, percent) {
    const { r, g, b } = hexToRgb(hex);
    const k = 1 - percent;
    return rgbToHex({ r: r * k, g: g * k, b: b * k });
}

/**
 * Применяет (или сбрасывает) кастомный акцентный цвет через CSS-переменные
 * --primary / --primary-700, читаемые Tailwind-классами и легаси-стилями.
 * customHex === null/undefined — сброс к цвету по умолчанию текущей темы (из tokens.css).
 */
export function applyPrimaryColor(customHex) {
    const root = document.documentElement;
    if (!customHex) {
        root.style.removeProperty("--primary");
        root.style.removeProperty("--primary-700");
        return;
    }
    root.style.setProperty("--primary", customHex);
    root.style.setProperty("--primary-700", darken(customHex, 0.12));
}

function apply(theme) {
    const root = document.documentElement; // <html>
    const dark = theme === "dark";
    root.classList.toggle("dark", dark);       // для Tailwind "dark:"
    root.dataset.theme = theme;                // для CSS-токенов [data-theme]
    root.style.colorScheme = theme;            // системные контролы
}

export function setTheme(next) {
    const value = next === "dark" ? "dark" : "light";
    localStorage.setItem(KEY, value);
    apply(value);
    // оповещение, если нужно реагировать в компонентах
    window.dispatchEvent(new CustomEvent("themechange", { detail: { theme: value } }));
}

export function toggleTheme() {
    setTheme(getTheme() === "dark" ? "light" : "dark");
}

export function initTheme() {
    apply(getTheme());
}
